
/** Css classes */
export enum IMXR_CLASSES {
    DROPDOWN = "xr-dropdown",
    BTN = "xr-btn",
    MENU = "xr-menu",
    MENU_ITEM = "xr-menu-item",
    TITLE = "xr-title",
    CARD = "xr-card"
}